import classNames from "classnames";

function LongText({id, formik, settings}) {
    return (
        <div className="long-text">
            <label className={classNames({"required": settings.required})}>
                {settings.title}
            </label>

            <textarea
                id={id}
                name={id}
                className="textarea"
                value={formik.values[id]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
            />
            {settings.description && <p className="description">{settings.description} </p>}

            {formik.touched[id] && formik.errors[id] && <p className="error">{formik.errors[id]}</p>}
        </div>
    )
}

export default LongText
